/* ==========================================================================
   GEMINI AMAZE EDITION - INTERACTIVE ANIMATIONS & SCROLL TRIGGERS
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  // 1. Animated Number Counters (50K+, 500+, 88%)
  const counters = document.querySelectorAll('[data-gemini-counter]');
  if (counters.length > 0 && 'IntersectionObserver' in window) {
    const counterObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const target = parseFloat(el.getAttribute('data-target')) || 0;
          const suffix = el.getAttribute('data-suffix') || '';
          const duration = 1600;
          const startTime = performance.now();

          function updateCount(now) {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = Math.floor(eased * target);
            el.textContent = current + suffix;
            if (progress < 1) {
              requestAnimationFrame(updateCount);
            } else {
              el.textContent = target + suffix;
            }
          }
          requestAnimationFrame(updateCount);
          obs.unobserve(el);
        }
      });
    }, { threshold: 0.35 });

    counters.forEach(c => counterObserver.observe(c));
  }

  // 2. Real-time Countdown Timer
  const timers = document.querySelectorAll('[data-gemini-countdown]');
  timers.forEach(timer => {
    const daysEl = timer.querySelector('[data-cd-days]');
    const hoursEl = timer.querySelector('[data-cd-hours]');
    const minsEl = timer.querySelector('[data-cd-mins]');
    const secsEl = timer.querySelector('[data-cd-secs]');
    let totalSeconds = (71 * 86400) + (19 * 3600) + (52 * 60) + 43;

    setInterval(() => {
      if (totalSeconds <= 0) return;
      totalSeconds--;
      const d = Math.floor(totalSeconds / 86400);
      const h = Math.floor((totalSeconds % 86400) / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
    }, 1000);
  });

  // 3. Avatar Tabs Switching (Image 5)
  document.querySelectorAll('[data-gemini-tabs]').forEach(section => {
    const tabs = section.querySelectorAll('.gemini-avatar-tab');
    const panels = section.querySelectorAll('.gemini-tab-panel');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('data-tab-target');
        tabs.forEach(t => t.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        const activePanel = section.querySelector('#' + targetId);
        if (activePanel) activePanel.classList.add('is-active');
      });
    });
  });

  // 4. Synced Split Product List & Progress Bar (Image 8)
  document.querySelectorAll('[data-gemini-synced]').forEach(section => {
    const cards = section.querySelectorAll('.gemini-synced-card');
    const images = section.querySelectorAll('.gemini-synced-preview-img');
    const segs = section.querySelectorAll('.gemini-progress-Seg');

    function activateIndex(idx) {
      cards.forEach((c, i) => c.classList.toggle('is-active', i === idx));
      images.forEach((img, i) => img.classList.toggle('is-active', i === idx));
      segs.forEach((seg, i) => seg.classList.toggle('is-active', i === idx));
    }

    cards.forEach((card, idx) => {
      card.addEventListener('mouseenter', () => activateIndex(idx));
      card.addEventListener('click', () => activateIndex(idx));
    });
    segs.forEach((seg, idx) => {
      seg.addEventListener('click', () => activateIndex(idx));
    });
  });

  // 5. Hero Shelf Horizontal Scroll Buttons (Image 4)
  document.querySelectorAll('[data-gemini-shelf]').forEach(section => {
    const track = section.querySelector('.gemini-shelf-track');
    const prevBtn = section.querySelector('[data-shelf-prev]');
    const nextBtn = section.querySelector('[data-shelf-next]');
    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => track.scrollBy({ left: -290, behavior: 'smooth' }));
      nextBtn.addEventListener('click', () => track.scrollBy({ left: 290, behavior: 'smooth' }));
    }
  });
});
